// extracted by mini-css-extract-plugin
export default {"popup_box":"PopUp_popup_box__yjCXB","box":"PopUp_box__5dP10","close_icon":"PopUp_close_icon__ZsOiP"};